module.exports = __webpack_public_path__ + "img/DD_1000_R.f90c1ea2.png";